import gql from 'graphql-tag'
import { User } from '~/graphql/fragments/user.js'

export const PostCourseAnswer = gql`
  fragment PostCourseAnswer on Answer {
    answerBy
    content
    insertedAt
    updatedAt
    id
    questionId
    reviewer {
      ...User
    }
  }
  ${User}
`

export const Course = gql`
  fragment Course on Course {
    id
    userId
    name
    desc
    slug
    cover
    type
    objectives
    published
    courseVersionIds
    updateStatus
    publishedAt
    learnMode
    language
    courseQuestionAndAnswers {
      id
      topic
      replies {
        id
        topic
        user {
          id
          fullName
          media {
            url
          }
        }
        updatedAt
      }
      user {
        id
        fullName
        media {
          url
        }
      }
      updatedAt
    }
    level
    inMyList
    materials
    schoolId
    rating
    courseUserRatings {
      userId
      id
      updatedAt
      rating
      user {
        name: fullName
        media {
          url
        }
      }
      evaluationStatus
    }
    courseSchoolPermissions {
      schoolId
      sharingOption
      enrollable
    }
    entryRequirement
    duration
    introVideoCount
    enrolledUsers {
      ...User
    }
    activityHistories {
      action
      insertedAt
      updatedAt
      userId
    }
    resources {
      label
      url
    }
    schedule {
      lessonCount
      lessonDuration
      structure
    }
    scheduleClasses {
      id
      name
      startDatetime
      endDatetime
      status
      videoLink
      full
      enrolledCount
      enrolledUsers {
        ...User
      }
      trainers {
        name
      }
      regularPeriod {
        schedule
        custom
        daysOfMonth
        daysOfWeek
        endDate
        month
        repeatEvery
        schedule
      }
      scheduleLessons {
        name
        startDatetime
        endDatetime
        rescheduled
        trainers {
          name
        }
        trainersLessons {
          trainer {
            name
          }
          replaced
        }
      }
    }
    schoolId
    setting {
      language
      maxCapacity
      minCapacity
    }
    validForCpd
    venue {
      location
      postalCode
      latitude
      longitude
      address_1
      address_2
    }
    skillArea
    status
    trainer {
      id
      name
      media {
        id
        url
      }
    }
    enrolled
    published
    publishedAt
    likedCount
    viewedCount
    enrolledCount
    courseEnrolls {
      userId
      status
      user {
        id
        name: fullName
        media {
          url
        }
      }
    }
    courseMedias {
      id
      media {
        thumbnail
        source
        url
        fileName
        id
        status
      }
      transcript
    }
    questions {
      content
      id
      isRequired
    }
    topics {
      id
      name
      parentId
      content {
        questions {
          id
          correctFeedback
          wrongFeedback
          point
          media {
            id
            url
          }
          options {
            media {
              id
              url
            }
            id
            right
            title
          }
          title
          desc
          type
        }
      }
      tags {
        value
      }
      order
      desc
      slug
      topicType
      mediaFromTime
      mediaToTime
      content {
        questions {
          id
          options {
            id
            right
            title
          }
          title
        }
      }
      media {
        thumbnail
        source
        url
        fileName
        scormMediaId
        id
        status
      }
    }
    insertedAt
    updatedAt
  }
  ${User}
`
